<template>
    <div class="container" style="margin-bottom:5rem;" :class="maxHeight? 'altura' : ''">
        <!-- Modal -->
        <div v-if="showModal"> <!---showModal--->
            <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-center text-muted">
                            <h4 class="modal-title">
                                <i class="fas fa-exclamation-triangle text-warning mr-2"></i> La sessión ha caducado
                            </h4>
                            <button type="button" class="close"  @click="forzarCierreSesion()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form v-on:submit.prevent="login" ref="formLogin">
                            <div class="modal-body">
                                <p class="mb-4 px-4" style="font-size:1.1rem; color:#ababab;">
                                    Para continuar viendo el contenido de éste módulo debe volver a iniciar session.
                                </p>
                                <!-- <div id="number"></div> -->
                                <!--  -->
                                    <div class="form-group mb-1 px-4">
                                        <label for="usuario" style="font-size: .8rem;">Usuario</label>
                                        <input type="text" v-model.trim="user"  class="form-control " id="usuario">
                                    </div>
                                    <div class="form-group px-4">
                                        <label for="password" style="font-size: .8rem;">Contraseña</label>
                                        <input type="password" v-model.trim="pass" class="form-control " id="password">
                                    </div>
                                    <p v-if="errores" class="small text-danger my-0"> {{errores==1? '*Debe llenar los campos, son obligatorios.' : '*Contraseña erronea'}} </p>
                                    <div class="mt-4 mb-3 px-4 text-center">
                                        <button type="submit" class="btn btn-primary px-5 py-2 d-block btn-block">Iniciar sesión</button>
                                        <!-- <button class="btn btn-link d-block btn-block mt-4" style="text-decoration-line: underline; font-weight:500">Cerrar</button>  -->
                                    </div>
                                <!--  -->
                            </div>
                        </form>
                        <div class="modal-footer">
                            <p class="text-muted">Esta ventana se cerrara en <span class="text-muted" id="number">{{segundos}}</span> seg.</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </transition>
        </div>
        <!-- Si existe un usuario en cache ver el contenido -->
        <div v-if="userName">
            <div id="" v-scroll-reveal>
                <div class="container px-0">
                    <!-- --- BUSCADOR DE TRAMITES ---- -->
                    <div class="menu-opciones mt-3">
                        <p class="p-0 m-0" style="color: rgb(176, 176, 176);">
                           <span class="name-User ml-2">
                                <!-- {{userName}}  --> <!---aqui va el nombre completo a la izq--->
                           </span>
                        </p>
                        <div class="dropdown">
                            <button class="btn btn-link dropdown-toggle m-0 p-0" style="color: #949494; font-size: .9rem;" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <span :class="modoDark_var? 'text-white' : ''"><i class="fas fa-bars ml-1 menu-movil" style="font-size:.8rem"></i>
                                {{userName}}
                                <i class="fas fa-bars ml-1 menu-pc" style="font-size:.8rem"></i>
                              </span>
                            </button>
                            <div class="dropdown-menu mr-3">
                                <a class="dropdown-item" @click="activarModal()">
                                    <i class="fas fa-key"></i>
                                    Cambiar contraseña
                                </a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" @click="cerrarSesion()">
                                   <i class="fas fa-sign-out-alt"></i>
                                   Cerrar sessión
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row mx-0 px-0 padding-card shadow" style="border-radius:5px; border: 1px solid #d3cece; border-left: 5px solid #f8006c ">
                        <div class="col-12">
                            <div class="row w-100">
                                <div class="col-12 col-sm-12 col-md-6 titulo-formatos w-100">
                                    <h3 class="py-3" :class="modoDark_var? 'text-white' : ''">Buscador de formatos</h3>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 contenedor-radios px-0">
                                    <div class="d-flex tipoFiltro my-3">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="tipo_filtro" id="subsecretarias" v-model="radioBuscador" :value="1">
                                            <label class="radio-label form-check-label label-left" :class="[radioBuscador==1? 'activo' : '', modoDark_var? 'text-white' : '']" for="subsecretarias">
                                              <span :class="modoDark_var? 'text-white' : ''">Órganos Administrativos</span>
                                             </label>
                                        </div>
                                        <div class="">
                                            <input class="form-check-input" type="radio" name="tipo_filtro" id="buscador"  v-model="radioBuscador" :value="2">
                                            <label class="radio-label form-check-label label-center" :class="[radioBuscador==2? 'activo' : '', modoDark_var? 'text-white' : '']" for="buscador">
                                              <span :class="modoDark_var? 'text-white' : ''">Buscador</span>
                                            </label>
                                        </div>
                                        <div class="d-none">
                                            <input class="form-check-input" type="radio" name="tipo_filtro" id="tramite"  v-model="radioBuscador" :value="3">
                                            <label class="radio-label form-check-label label-right" :class="radioBuscador==3? 'activo' : ''" for="tramite">N° Trámite</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- BUSQUEDA POR SUBSECRETARIA Y DIRECCION -->
                        <div v-if="radioBuscador==1" class="col-6">
                            <label for="subsecretarias">
                              <span :class="modoDark_var? 'text-white' : ''"> Órganos Administrativos</span>
                            </label>

                            <select v-model="subsecretaria" class="custom-select custom-select-lg" id="subsecretarias">
                                <option v-for="n in listaSubsecretarias" :key="n.id" :value="n.id">{{n.descripcion}}</option>
                            </select>
                        </div>

                        <div v-if="radioBuscador==1" class="col-6">
                            <label for="direcciones">
                              <span :class="modoDark_var? 'text-white' : ''"> Direcciones o Equivalentes </span>
                            </label> <!---{{ direccion }}--->
                            <select v-model="direccion" class="custom-select custom-select-lg" id="direcciones" :disabled="!subsecretaria || banderaDirecciones">
                                <option v-for="n in listaDirecciones" :key="n.id" :value="n.id"> {{n.descripcion}} </option>
                            </select>
                        </div>
                        <!-- BUSQUEDA POR PALABRA (BUSCADOR) -->
                        <div v-if="radioBuscador==2" class="col-12  mb-3">
                            <label for="subsecretarias">
                              <span :class="modoDark_var? 'text-white' : ''">Buscador palabras clave</span>
                            </label>
                            <div class="input-group">
                                <input type="text"  v-on:keyup.enter="formatosBuscadorGenerico" v-model.trim="palabraClave" class="form-control form-control-lg" placeholder="Ingrese una palabra..." aria-label="Recipient's username" aria-describedby="button-addon2">
                                <div class="input-group-append">
                                    <button @click="formatosBuscadorGenerico()" class="btn color-grey padding-search" type="button" id="button-addon2"><i class="fas fa-search"></i></button>
                                </div>
                            </div>
                            <span v-if="errorPalabra" class="mt-0 d-block text-danger" style="font-size:.8rem;">*Debe colocar al menos una palabra</span>
                        </div>
                        <!-- BUSQUEDA POR N° DE TRAMITE (BUSCADOR) -->
                        <div v-if="radioBuscador==3" class="col-12 mb-3">
                            <label for="subsecretarias">Buscador por numero de trámite</label>
                            <div class="input-group">
                                <input type="text" v-on:keyup.enter="getTramite" v-model="tramite" class="form-control form-control-lg" placeholder="N° de trámite" aria-label="Recipient's username" aria-describedby="button-addon2">
                                <div class="input-group-append">
                                    <button @click="getTramite()" class="btn color-grey padding-search" type="button" id="button-addon2"><i class="fas fa-search"></i></button>
                                </div>
                            </div>
                            <span v-if="errorNumTramite" class="mt-0 d-block text-danger" style="font-size:.8rem;">*Debe escribir el número de trámite</span>
                        </div>

                    </div>
                    <!-- <code> {{direccion}} </code>
                    <code> {{listaBusquedaPalabra}} </code>
                    <code> {{listaFormatos}} </code> -->
                    <!-- --- FIN BUSCADOR DE TRAMITES ---- -->

                <div v-if="load" class="text-center">
                        <spiner></spiner>
                        <p class="mt-0">Buscando formatos...</p>
                </div>

                <div v-if="banderaDirecciones && !load" class="text-center">
                    <p v-for="n in listaSubsecretarias" :key="n.id" class="text-muted" style="font-size:1.2rem">
                        {{ n.id==subsecretaria? 'La Subsecretaria '+n.descripcion+' no posee direcciones' : ''}}
                        </p>
                </div>

                    <!-- ---- CARDS DE TRAMITES Y FORMATOS ---- -->
                    <div v-if="listaFormatos.length>0">
                        <h5 class="mt-4 h2" :class="modoDark_var? 'text-white' : ''">Formatos</h5>
                        <div v-for="n in listaFormatos" :key="n.id" class="w-100 my-3 bg-light px-4 pt-3 pb-2 card-formatos" style="/*border-left:6px solid #ad985f; border-radius:5px;*/">
                            <div class="d-flex justify-content-between mb-0">
                                <h4 class="text-dark">{{n.nombre}}</h4> <p class="my-0">
                                    <small class="text-muted border px-2" style="font-size:.9rem; /*background:#ededed; border-radius:5%; padding:.3rem;*/">
                                        {{n.categoria}}
                                    </small>
                                </p>
                            </div>
                            <p class="mt-0 text-muted" style="/*font-size:.9rem;*/">{{n.codigoFormato}} | Revisión y fecha: {{n.revision}} {{n.fechaVigor}} </p>
                            <p class="text-muted mb-0 mt-1">
                                {{n.descripcion}}
                            </p>
                            <p class="mt-0 mb-4 p-0 text-muted"># {{n.palabrasClave}}</p>
                            <div>
                                <!-- <ul class="listaFormatos" style="white-space: nowrap; overflow-x: auto;">
                                    <li><a :href="n.urlServicioTramite" target="_blank"><i class="fas fa-link"></i> Trámite</a></li>
                                    <li><a :href="n.urlAvisoPrivacidad" target="_blank">Aviso de privacidad</a></li>
                                    <li><a :href="n.urlManual" target="_blank">Instructivo de llenado</a></li>
                                    <li><a :href="n.urlFormato" target="_blank">Formato__</a></li>
                                </ul> -->
                                <ul class="listaFormatos" style="white-space: nowrap; overflow-x: auto;">
                                    <li><a :href="n.urlServicioTramite" target="_blank"><i class="fas fa-link"></i> Trámite</a></li>
                                    <li><a :href="n.urlAvisoPrivacidad" target="_blank">Aviso de privacidad</a></li>
                                    <li><a :href="n.urlManual? urlDescarga(n.codigoFormato,2) : '#'" :target="n.urlManual? '_blank' : ''">Instructivo</a></li>
                                    <li><a :href="n.urlFormato? urlDescarga(n.codigoFormato,1) : '#'" :target="n.urlFormato? '_blank' : ''">Formato</a></li>
                                    <li><a :href="n.urlFormato? urlDescarga(n.codigoFormato,3) : '#'" :target="n.urlFormato? '_blank' : ''">.zip</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="banderaSinResultados && !load" class="container">
                        <div class="no-result text-center mb-3">
                            <p class="sinResult text-muted">Sin resultados</p>
                            <i class="far fa-frown fa-2x"></i>
                        </div>
                    </div>
                </div>
            </div>

        <div v-if="modalActivo">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header text-center text-muted">
                                    <h4 class="modal-title">
                                        <i class="fas fa-exclamation-triangle text-warning mr-2"></i> Cambiar contraseña
                                    </h4>
                                </div>
                                <div class="form-group mb-1 px-4 mb-2">
                                    <label for="usuario" style="font-size: .8rem;">Contraseña actual</label>
                                    <input type="password" v-model="oldPass" class="form-control " id="usuario">
                                </div>
                                <div class="form-group px-4 mb-0">
                                    <label for="password" style="font-size: .8rem;">Contraseña Nueva</label>
                                    <input type="password" v-model="newPass" class="form-control " id="password">
                                </div>
                                <div class="form-group px-4">
                                    <label for="password" style="font-size: .8rem;">Repetir contraseña Nueva</label>
                                    <input type="password" v-model="newPass2" class="form-control " id="password">
                                    <small v-if="erroresPass" class="text-danger">
                                        <span v-if="erroresPass==1" >*La contraseña nueva no coincide</span>
                                        <span v-else-if="erroresPass==2" >*La contraseña actual es incorrecta</span>
                                        <span v-else-if="erroresPass==3">*Debe llenar todos los campos</span>
                                        <span v-else-if="erroresPass==4">*La contraseña debe tener al menos 8 caracteres</span>
                                    </small>
                                </div>
                                <p v-if="errores" class="small text-danger my-0"> {{errores==1? '*Debe llenar los campos, son obligatorios.' : '*Contraseña erronea'}} </p>
                                <p v-if="passCambiada>0" class="px-4" :class="passCambiada==1? 'text-success' : 'text-danger'">
                                    <i :class="passCambiada==1? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                    {{passCambiada==1? 'Contraseña cambiada' : 'No se pudo cambiar la contraseña'}}
                                </p>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-vino-o" @click="cerrarModal()">Cerrar</button>
                                    <button type="button" class="btn btn-vino" @click="cambiarPass()">Guardar Cambios</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>



            <!-- esto es un padding q le pongo para que el footer no se eleve en pantallas grandes -->
            <div v-if="maxHeight && listaFormatos.length<3" style="padding-bottom:30%;"></div>

        </div>
        <!-- De lo contrario ir a la pantalla de inicio de sesión -->
        <div v-else>
            {{this.$router.push({name: 'loginRegistro'})}}
        </div>
    </div>
</template>
<script>

import axios from "axios";
import logueoModal from './components/login.vue'
import spiner from '../../views/spiner.vue'
import datatables from '../../../src/models/DataTables';
import ServicesTramiteshacienda from '../../services/serviciosTramites'
import AutorizacionTramiteshacienda from "./../../services/autorizacionTramites"
import { mapState } from "vuex";
// import ReCapcha from '../capcha.vue'
const _serviciosHacienda = new ServicesTramiteshacienda();
const _servicesAuth = new AutorizacionTramiteshacienda();
export default({
    name: 'tramites',
    mixins : [datatables],
    components:{ spiner, logueoModal },
    data: function(){
        return{
            token: '',
            subsecretaria: '',
            direccion: '',
            formato: '',
            tramite: '',
            palabraClave: '',
            radioBuscador: 1,

            //datos del modal autenticacion
            user:'',
            pass: '',
            errores: 0,

            // datos del modal cambio de pass
            oldPass: '',
            newPass: '',
            newPass2: '',
            modalActivo: false,
                // erroresPass: 1= pass no coinciden, 2=clave vieja invalida, 3=campos vacios, 4=menor a 8 caracteres
            erroresPass: 0,
                //passCambiada: 1=pass cambiada, 2=pass no cambiada
            passCambiada:0,

            // captcha
            verCaptcha: '',
            inputCaptcha: '',

            errorPalabra: false,
            errorNumTramite: false,

            cambioSubsecretaria: false,
            banderaDirecciones: false,
            banderaSinResultados: false,
            load: false,
            // -- listas -----
            listaSubsecretarias: [],
            listaDirecciones: [],
            listaFormatos: [],

            showModal: false,
            segundos: 40, ///aqui poner 0
            ivl: 0,
            speed: 1000

        }
    },
    computed:{
        maxHeight(){ return window.screen.height>800? true : false },
        // usuarioLogueado(){ return _serviciosHacienda.getUsuarioPass(); },
        userName(){ return _serviciosHacienda.getUsuarioName() },
        //  ...mapState(['idUsuario'])
        ...mapState(['modoDark_var'])

    },
    methods: {
      urlDescarga(formato, tipo){
          let cadena = formato.split('/');
          cadena = cadena.join('');
          switch (tipo) {
            case 1: return "https://presupuesto."+this.urlSubdominio+"SAF/descargas/formato?nc="+cadena;
            case 2: return "https://presupuesto."+this.urlSubdominio+"SAF/descargas/instructivo?nc="+cadena;
            case 3: return "https://presupuesto."+this.urlSubdominio+"SAF/descargas/zip?nc="+cadena;
          }
        },
        tramitesToken: async function(){
            let result = null;
            result = await _serviciosHacienda.GetToken();
            if(result.success){
                this.token = result.data;
                _serviciosHacienda.setUserToken(this.token);
                // console.log('TOKEN OBTENIDO');
                // console.log('_serviciosHacienda.getUserToken() = '+_serviciosHacienda.getUserToken());
            }
            else{ console.log(result.error); }
            this.subsecretarias(this.token);

        },

        subsecretarias: async function(){
            this.session_activa();
            let result = null;
            result = await _serviciosHacienda.Subsecretarias();
            this.listaSubsecretarias = result.data;
            if(result == 'Error: Request failed with status code 401'){
                //console.log('TOKEN VENCIDO, OBTENIENDO UNO NUEVO');
                this.tramitesToken();
            }
            // console.log(this.listaSubsecretarias );
        },
        direcciones: async function(idsubsecretaria){
            this.session_activa();
            let result = null;
            this.load = true;
            this.banderaSinResultados = false;
            result = await _serviciosHacienda.GetDirecciones(idsubsecretaria); //result = await _serviciosHacienda.GetDirecciones(this.token,idsubsecretaria);
            this.listaDirecciones = result.data;
            this.load = false;
            // console.log(this.listaDirecciones);
            // if(this.listaDirecciones.lenght == 0) this.banderaSinResultados = true;
        },
        formatos: async function(idFormatos){
            this.session_activa();
            this.listaFormatos = [];
            let result = null;
            this.load = true;
            result = await _serviciosHacienda.GetFormatos(this.token,idFormatos);
            this.listaFormatos = result.data;
            this.load = false;
            //console.log(result);
        },
        //buscador de formatos antiguo.. lo deje x si acaso
        formatosBuscador: async function(){
            this.session_activa();
            if(this.palabraClave == ''){
                this.errorPalabra = true;
                return;
            }
            this.listaFormatos = [];
            let result = null;
            this.load = true;
            result = await _serviciosHacienda.GetBuscadorFormatos(this.token,this.palabraClave);
            this.listaFormatos = result.data;
            // console.log(result);
            this.load = false;
            this.palabraClave = '';
            this.subsecretaria = '';
            this.direccion = '';
        },
        formatosBuscadorGenerico: async function(){
            if(this.palabraClave == ''){
                this.errorPalabra = true;
                return;
            }
            this.listaFormatos = [];
            let result = null;
            this.load = true;
            result = await _serviciosHacienda.filtroGenericoFormatos(0, 0, 0, this.palabraClave);
            this.listaFormatos = result.data;
            // console.log(result);
            this.load = false;
            this.palabraClave = '';
            this.subsecretaria = '';
            this.direccion = '';
        },
        getTramite: async function(){
            this.session_activa();
            if(this.tramite == ''){
                this.errorNumTramite = true;
                return;
            }
            this.listaFormatos = [];
            let result = null;
            this.load = true;
            result = await _serviciosHacienda.GetTramite(this.token,this.tramite);
            this.listaFormatos = result.data;
            // console.log(result);
            this.load = false;
            this.tramite = '';
            this.subsecretaria = '';
            this.direccion = '';
        },
        /**
         * Funcion que verifica si token de sesion esta activo
         * @return true o false, para saber si puede ver el contenido de esta vista
         */
        session_activa: async function(){
            let token = await _serviciosHacienda.getTokenAuth();
            if(!token){
                this.$router.push({name: 'loginRegistro'})
                return false; // <-- detiene la ejecucion si no encuentra token de auth en la cookie
            }

            let result = null;

            result = await _servicesAuth.VerificacionToken(token);
            //console.log('💛🧡🧡', result);

            if(result.data == false){
                //console.log('token malo');
                this.segundos = 40;
                this.user = "";
                this.pass = "";
                this.errores = 0;
                this.abrirModal();
                return false;
            }//else console.log('el token esta activo');
            return result.data;
        },
        updateTimer() {
            // this.segundos = 40;
            // this.pass = "";
            // this.errores = 0;
            this.ivl = setInterval(()=>{
                    //console.log('tick...')
                    this.segundos = this.segundos - 1
                    if (this.segundos == 0) {
                        this.forzarCierreSesion();
                    }
            }, this.speed)
        },
        abrirModal(){
            this.showModal = true;
            this.updateTimer();
        },
        login: async function(){
            //errores = 1 campos vacios, 2 campos erroneos
            if(this.pass == '' || this.user == ''){
                this.errores = 1;
                return
            }

            let result = null;
            // let usuario = this.usuarioLogueado;
            result = await _servicesAuth.LoginUser(this.user, this.pass);

            // si la peticion es exitosa...
            if(result.success){
               _servicesAuth.setTokenAuth(result.data.token);
                clearInterval(this.ivl);
                this.showModal = false;
            }else if(result.error == 400) this.errores = 2;

            //console.log(result);
        },

        activarModal(){
            this.oldPass = '';
            this.newPass = '';
            this.newPass2 = '';
            this.passCambiada = 0;
            this.modalActivo = true;
        },
        cerrarModal(){this.modalActivo = false;},
        cambiarPass: async function(){

            if(this.oldPass=='' || this.newPass=='' || this.newPass2==''){
                this.erroresPass = 3;
                return 0;
            }
            if(this.newPass!==this.newPass2) {
                this.erroresPass = 1;
                return 0;
            }
            if(this.newPass.length<8){
                this.erroresPass = 4;
                return 0;
            }

            let idUsuario = await _serviciosHacienda.getIdUsuario();
            idUsuario = parseInt(idUsuario);
            let token_autenticacion = _serviciosHacienda.getTokenAuth();

            let object_body = {
                'idUsuario': idUsuario,
                'password_old': this.oldPass,
                'password_new': this.newPass,
                'token': token_autenticacion
            }
            let config_Serve = {
                method: 'put',
                url: this.$urlServidor+'key/api/Auth/Change_password',
                headers: {
                    'Authorization' : 'Bearer' + ' ' +token_autenticacion,
                    'Content-Type': 'application/json'
                },
                data : object_body
            };
            axios(config_Serve)
            .then(response => {
                //console.log(response);
                this.passCambiada = 1;
                setTimeout(() => this.modalActivo = false, 1600);

            })
            .catch(error => {
                if(error.response.status == 400){
                    this.erroresPass = 2;
                    return 0;
                }else{
                    console.log(error);
                }
            });


        },



        // funcion que inicia con lo necesario al ser creado el componente
        init: async function(){
            let validarSesion = await this.session_activa();
            if(validarSesion==false) return;

            await _serviciosHacienda.getTokenAuth();
            if(_serviciosHacienda.getUserToken()){
                //console.log('hay token');
                this.token = _serviciosHacienda.getUserToken();
                this.subsecretarias();
            }else{
                this.tramitesToken();
            }
        },
        // cerrando sesion
        cerrarSesion(){
            _serviciosHacienda.deleteUserLogged();
            this.$router.push({name: 'loginRegistro'})
        },
        //cierre de sesión forzado
        forzarCierreSesion(){
            this.cerrarSesion();
            this.showModal = false;
            clearInterval(this.ivl);
        }

    },
    created(){
        this.init();
    },
    mounted(){
       window.scrollTo(0, 0);
    },
    watch:{
        subsecretaria: function(){
            if(this.subsecretaria){
                this.direcciones(this.subsecretaria);
                this.cambioSubsecretaria = true;
                this.listaFormatos = [];
            }
        },
        direccion: function(){
           if(this.direccion) this.formatos(this.direccion);
        },
        listaFormatos: function(){
          // console.log('listaFormatos', this.listaFormatos);
            if(this.cambioSubsecretaria){
                this.cambioSubsecretaria = false;
                return;
            }
            if(this.listaFormatos.length == 0) this.banderaSinResultados = true;
            else this.banderaSinResultados = false;
        },
        listaDirecciones: function(){
          // console.log('listaDirecciones', this.listaDirecciones);
            if(this.listaDirecciones.length>0) this.banderaDirecciones = false;
            else {
                this.banderaDirecciones = true;
                this.listaFormatos = [];
            }
        },
        palabraClave: function(){
            if(this.palabraClave != '') this.errorPalabra = false;
        },
        tramite: function(){
            if(this.tramite != '') this.errorNumTramite = false;
        },
        // verifica que la contraseña tenga mas de 8 caracteres
        newPass: function(){
            if(this.newPass.length<8) this.erroresPass = 4;
            else this.erroresPass = 0;
        },
        // contraseñas cambiadas reactivamente
        newPass2: function(){
            if(this.newPass !== this.newPass2) this.erroresPass = 1;
            else this.erroresPass = 0;
        }

    }
})
</script>
<style scoped>
    /* quita flecha del dropdown */
    .dropdown-toggle::after { display:none; }
    .dropdown-item{
        cursor:pointer;
        color: #595959;
    }

    .menu-opciones{
        display: flex;
        justify-content: space-between;
    }
    .menu-movil{ display: none;}
    .menu-pc{ display: contents; }

    .name-User{
        display: inline-block;
        font-size: .89rem !important;
    }
    #formulario-login .container{
        max-width: 1000px !important;
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }
    #formulario-login .img{width:25%;}
    label{
        color: rgb(99, 97, 97) !important;
        margin-bottom: 0 !important;
        font-size: 1.05rem;
    }
    #formulario-login .tramite{
        width: 30%;
        background-color: #f7f7f7;
        display: flex !important;
        align-items: center !important;
        /* background-image: url(img.jpg); */
    }
    #formulario-login .login{
        padding: .5rem 2rem 4rem 2rem;

    }
    #formulario-login label{ font-size: .8rem; color: #b2afaf; }
     #formulario-login h5{
        font-size: 1.7rem;
        font-weight: 400;
        color: #625151;
    }
    .title-tramite { letter-spacing: auto; font-weight: 500; }

    .card-formatos{
        border-radius:5px;
        border-top: 1px solid #dadada;
        border-right: 1px solid #dadada;
        border-bottom: 1px solid #dadada;
        border-left:6px solid #ad0d33;
        box-shadow: 0px 2px 5px #c8c8c8;
    }


    .listaFormatos{ display: flex; margin: 1rem 0 0 0; padding-left: 0;}
    .listaFormatos li { list-style:none; margin-right: 1rem; }
    .listaFormatos li a {
        color: rgb(102,99,99);
        /* text-decoration:underline; */
        border-radius: 10px;
        background: #ededed;
        /* padding: 1rem; */
        padding-right: 1rem;
        padding-left: 1rem;
        padding-top: .1rem;
        padding-bottom: .1rem;
    }


    /* ---- configuración de filtros ---- */

    .radio-label{ color: #621132; font-size: 0.8rem;}
    .tipoFiltro input{ visibility: hidden;}
    .tipoFiltro label{
        border:1px solid #ad0d33 ;
        padding: .3rem 1rem;
        cursor: pointer;
    }
     .tipoFiltro .label-left{  border-right: 0; border-top-left-radius: 4px; border-bottom-left-radius: 4px; }
     .tipoFiltro .label-center{ border-top-right-radius: 4px; border-bottom-right-radius: 4px; /*border-top-right-radius: 0; border-bottom-right-radius: 0; border-right: 0;*/}
     .tipoFiltro .label-right{ border-top-right-radius: 4px; border-bottom-right-radius: 4px; }
     .activo {
         background: #ad0d33 ;
         font-weight: 400;
         /* border: 2px solid #82415c; */
         color: white !important;
     }
     /* sin resultados de la busqueda */
    .no-result{ margin-top: 3rem !important; }
    .no-result i {color: #aeb5ba !important;}
    .sinResult{
        color: #aeb5ba !important;
        font-size: 1.3rem;
        margin-bottom: 0;
    }

    .form-control:focus { box-shadow: none; }
    .btn.focus, .btn:focus { box-shadow: none; }
    /* .altura{ height: 60vh !important;} */

    .color-grey{ border: 1px solid #ced4da; }
    .color-grey i {color: grey; font-size: 1.2rem;}
    .color-grey:hover{ background: #ededed; }


    .padding-card{
        padding-left: 3rem !important;
        padding-bottom: 3rem !important;
        padding-right: 3rem !important;
    }
    .padding-search{
        padding-left: 3rem !important;
        padding-right: 3rem !important;
    }
    .titulo-formatos h4{
        padding-top: 1rem !important;
        padding-bottom: 1rem !important;
        /* display: flex;
        justify-content: end; */
    }

    .contenedor-radios{
        display: flex;
        justify-content: flex-end;
    }

    .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}


/* ########### MEDIA QUERYS <900PX (CELULARES) ############# */
@media only screen and (max-device-width : 900px) {
    .name-User{ display: none; }
    .padding-card{
        padding-left: .6rem !important;
        padding-right: .6rem !important;
        padding-bottom: .6rem !important;
    }
    .tipoFiltro label{ padding: .4rem .6rem; }
    .padding-search{
        padding-left: .9rem !important;
        padding-right: .9rem !important;
    }
    .titulo-formatos h4{
        font-size: 1.25rem !important;
        margin-bottom: 0 !important;
    }
    .contenedor-radios{ justify-content: start; }

     .menu-opciones{
        justify-content: start;
    }
    .menu-movil{ display: contents;}
    .menu-pc{ display: none; }

}

#number {
  /* font-size:50px; */
  color:#434343;
}
</style>
